import * as actionTypes from './actionTypes'

export function updateBondInfoField(field, payload) {
  return {
    type: actionTypes.UPDATE_BOND_INFO_FIELD,
    payload,
    field
  }
}

export function updateAdditionalBondInfoField(index, field, payload) {
  return {
    type: actionTypes.UPDATE_ADDITIONAL_BOND_INFO_FIELD,
    payload,
    field,
    index
  }
}

export function addAdditionalBond() {
  return {
    type: actionTypes.ADD_ADDITIONAL_BOND
  }
}

export function removeAdditionalBond(index) {
  return {
    type: actionTypes.REMOVE_ADDITIONAL_BOND,
    payload: index
  }
}
